/*
 * Base Google Map example
 */
import React, { Component } from 'react';

import GoogleMapReact from 'google-map-react';
import './SingleMarkerMap.css'


class SingleMarkerMap extends Component {

    constructor(props) {
        super(props);
        this.renderMarkers = this.renderMarkers.bind(this)
    }
    
    renderMarkers = (map, maps, markerPos, customerName) => {
        let marker = new maps.Marker({
            position: {lat: markerPos.lat, lng: markerPos.lng},
            map,
            title: customerName
        });
        marker.addListener("click", () => {
            window.open(`http://maps.google.co.th/maps?q=${markerPos.lat},${markerPos.lng}`, '_blank').focus();
        });
        return marker;
    };

    render() {
        const { markerPos, customerName } = this.props
        return (
            <div style={{ aspectRatio: 1, width: '100%' }}>
                <div style={{ height: '100%', width: '100%' }}>
                    <GoogleMapReact
                        apiKey={"AIzaSyAdbJX-7pT5ANftYb4rpQc3Md3xIclasos"} // set if you need stats etc ...
                        center={markerPos}
                        defaultZoom={14}
                        onGoogleApiLoaded={({ map, maps }) => this.renderMarkers(map, maps, markerPos, customerName)}
                    >
                        {/* <Marker lat={markerPos.lat} lng={markerPos.lng} draggable={false} /> */}
                        
                    </GoogleMapReact>

                </div>
            </div>
        );
    }
}

const Marker = props => {
    return <div className="map-marker"></div>
}

export default SingleMarkerMap;